import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Grid,
    GridItem,
    VStack,
    Text,
    HStack,
    useDisclosure, useToast, Button, useBreakpointValue, Image, Icon,
} from '@chakra-ui/react';
import {useTranslation} from "react-i18next";

const DocumentGridAudiobooksEmpty = () => {
    const {t} = useTranslation();
    const isMobile = useBreakpointValue({ base: true, md: false });

    return (
        <VStack width={['95%','88%', '78%', '68%', '58%']} mt={-8}>
            <VStack spacing={6} width={'100%'} bg={'white'} mb={'10rem'} pb={8}>
                {/* Main Heading */}
                <VStack spacing={2}>
                    <Text
                        fontSize={{ base: 'xl', md: '2xl' }}
                        fontWeight={'bold'}
                        color={'gray.800'}
                        textAlign={'center'}
                    >
                        {t("Analyze Important Images")}
                    </Text>
                    <Text
                        fontSize={{ base: 'md', md: 'lg' }}
                        color={'gray.600'}
                        textAlign={'center'}
                        maxW={'600px'}
                        mt={2}
                    >
                        {t("Upload images and get intelligent answers + analysis")}
                    </Text>
                </VStack>

                {/* Use Cases Grid */}
                <Grid
                    templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
                    gap={4}
                    width={'100%'}
                    maxW={'700px'}
                    mt={4}
                >
                    {/* Math & Equations */}
                    <GridItem>
                        <Box
                            bg={'orange.50'}
                            borderRadius={'lg'}
                            p={5}
                            border={'1px solid'}
                            borderColor={'orange.200'}
                            height={'100%'}
                        >
                            <HStack spacing={3} mb={2}>
                                <Text fontSize={'2xl'} role="img" aria-label="identify">🔍</Text>
                                <Text fontSize={'md'} fontWeight={'bold'} color={'orange.600'}>
                                    {t("Identify")}
                                </Text>
                            </HStack>
                            <Text fontSize={'sm'} color={'gray.700'} lineHeight={'tall'}>
                                {t("Find all images containing a certain object or text.")}
                            </Text>
                        </Box>
                    </GridItem>

                    {/* Screenshots & Documents */}
                    <GridItem>
                        <Box
                            bg={'blue.50'}
                            borderRadius={'lg'}
                            p={5}
                            border={'1px solid'}
                            borderColor={'blue.200'}
                            height={'100%'}
                        >
                            <HStack spacing={3} mb={2}>
                                <Text fontSize={'2xl'} role="img" aria-label="organize">🏷️</Text>
                                <Text fontSize={'md'} fontWeight={'bold'} color={'blue.600'}>
                                    {t("Organize")}
                                </Text>
                            </HStack>
                            <Text fontSize={'sm'} color={'gray.700'} lineHeight={'tall'}>
                                {t("Categorize and tag images based on content or themes.")}
                            </Text>
                        </Box>
                    </GridItem>

                    {/* Diagrams & Charts */}
                    <GridItem>
                        <Box
                            bg={'purple.50'}
                            borderRadius={'lg'}
                            p={5}
                            border={'1px solid'}
                            borderColor={'purple.200'}
                            height={'100%'}
                        >
                            <HStack spacing={3} mb={2}>
                                <Text fontSize={'2xl'} role="img" aria-label="transcribe">✍️</Text>
                                <Text fontSize={'md'} fontWeight={'bold'} color={'purple.600'}>
                                    {t("Transcribe")}
                                </Text>
                            </HStack>
                            <Text fontSize={'sm'} color={'gray.700'} lineHeight={'tall'}>
                                {t("Transcribe text from images such as license plates, street signs, etc.")}
                            </Text>
                        </Box>
                    </GridItem>

                    {/* Text & Documents */}
                    <GridItem>
                        <Box
                            bg={'green.50'}
                            borderRadius={'lg'}
                            p={5}
                            border={'1px solid'}
                            borderColor={'green.200'}
                            height={'100%'}
                        >
                            <HStack spacing={3} mb={2}>
                                <Text fontSize={'2xl'} role="img" aria-label="more">➕</Text>
                                <Text fontSize={'md'} fontWeight={'bold'} color={'green.600'}>
                                    {t("And Much More")}
                                </Text>
                            </HStack>
                            <Text fontSize={'sm'} color={'gray.700'} lineHeight={'tall'}>
                                {t("Analyze for details and more, depending on your needs.")}
                            </Text>
                        </Box>
                    </GridItem>
                </Grid>

                {/* Call to Action */}
                <Box
                    mt={4}
                    px={6}
                    py={3}
                    bg={'gray.50'}
                    borderRadius={'md'}
                    border={'1px solid'}
                    borderColor={'gray.200'}
                >
                    <Text
                        fontSize={'sm'}
                        color={'gray.600'}
                        textAlign={'center'}
                        fontWeight={'medium'}
                    >
                        ✨ {t("Upload your first image(s) above to get started")} ✨
                    </Text>
                </Box>
            </VStack>
        </VStack>
    );
};

export default DocumentGridAudiobooksEmpty;
